import React from 'react';
import { FieldError, UseFormRegisterReturn } from 'react-hook-form';
interface InputProps {
   label:string;
   register: UseFormRegisterReturn;
    error?: FieldError;
    required?: boolean;
    placement:string;
    className:string;
    disabled?:boolean;
  }
const InputField:React.FC<InputProps> = ({ label, register, required,error,placement,className,
  disabled = false 
 }) => (
    <>
      <div className={`form-group mb-4 sm:mb-0`}>
    <label className="mb-1 ml-1 font-semibold text-gray-700 text-sm">
      {label}
      {required && <span className="font-[400]"> (Required)</span>}
    </label>
    <input
      {...register} placeholder={placement}
      className={`form-control p-2 rounded mt-1 w-full ${className} ${error ? 'border-[#B91C1C] border-2' : 'border-gray-300 border'}`}
      disabled={disabled}
    />
    {error && <span className="text-[#B91C1C]">{error.message}</span>}
  </div>
    </>
  );

export default InputField
